import { z } from "zod";

const envSchema = z.object({
  VITE_API_BASE_URL: z
    .string()
    .url({ message: "VITE_API_BASE_URL must be a valid URL" }),
  VITE_MOCK_MODE: z.string().transform((val) => val === "true"),
  VITE_APP_VERSION: z.string().default("0.0.1"),
  VITE_LOG_LEVEL: z.enum(["debug", "info", "warn", "error"]).default("info"),
  VITE_WS_URL: z.string().url({ message: "VITE_WS_URL must be a valid URL" }),
  VITE_SESSION_TIMEOUT: z
    .string()
    .transform(Number)
    .pipe(
      z
        .number()
        .min(1, { message: "VITE_SESSION_TIMEOUT must be a positive number" })
    ),
  VITE_TOKEN_REFRESH_THRESHOLD: z
    .string()
    .transform(Number)
    .pipe(
      z.number().min(1, {
        message: "VITE_TOKEN_REFRESH_THRESHOLD must be a positive number",
      })
    ),
});

const parsedEnv = envSchema.safeParse(import.meta.env);

if (!parsedEnv.success) {
  console.error(
    "❌ Invalid environment variables:",
    parsedEnv.error.flatten().fieldErrors
  );
  throw new Error(
    "Invalid environment variables. Please check your .env file and ensure all required variables are set correctly."
  );
}

const env = parsedEnv.data;

export const config = {
  apiBaseUrl: env.VITE_API_BASE_URL,
  mockMode: import.meta.env.DEV && env.VITE_MOCK_MODE,
  appVersion: env.VITE_APP_VERSION,
  logLevel: env.VITE_LOG_LEVEL,
  wsUrl: env.VITE_WS_URL,
  sessionTimeout: env.VITE_SESSION_TIMEOUT,
  tokenRefreshThreshold: env.VITE_TOKEN_REFRESH_THRESHOLD,
};
